import { UPDATE_SALES_WIDGET } from "./actionTypes"

export const updateSalesWidget = data => {
  return {
    type: UPDATE_SALES_WIDGET,
    payload: data,
  }
}
